import { useQueries } from '@tanstack/react-query';
import axios from 'axios';

export interface CredentialGlobalProperty {
  id: string;
  name: string;
  aiq_type: string;
  origin: string;
}

export const CREDENTIAL_PICKER_AIQ_TYPES = ['UserPrivileges'] as const;
type CredentialAiqType = (typeof CREDENTIAL_PICKER_AIQ_TYPES)[number];

interface PaginatedScenarioGlobalProperties {
  results: CredentialGlobalProperty[];
}

const fetchByAiqType = async (aiqType: CredentialAiqType): Promise<CredentialGlobalProperty[]> => {
  const { data } = await axios.get<PaginatedScenarioGlobalProperties>('/v1/scenario_global_properties', {
    params: { aiq_type: aiqType, page_size: 1000 }
  });
  return data.results;
};

export const useCredentialGlobalProperties = () =>
  useQueries({
    queries: CREDENTIAL_PICKER_AIQ_TYPES.map(aiqType => ({
      queryKey: ['/v1/scenario_global_properties/credentials', { aiq_type: aiqType }] as const,
      queryFn: () => fetchByAiqType(aiqType)
    })),
    combine: results => ({
      data: results.flatMap(r => r.data ?? []),
      isLoading: results.some(r => r.isLoading)
    })
  });
